import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross and Blue Shield of Alabama",
  shortName: "BCBS Alabama",
  slug: "bcbsal-insurance",
  seoTitle:
    "Blue Cross and Blue Shield of Alabama TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross and Blue Shield of Alabama policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBS Alabama TMS coverage, Blue Cross Blue Shield Alabama SPRAVATO authorization, BCBSAL mental health benefits Coral Springs FL, BCBS Alabama depression treatment Florida",
};

export const BcbsalInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbsalInsurance;
